const CHANGE_HEADER_TITLE_PROPS = 'CHANGE_HEADER_TITLE_PROPS';
const RESET_HEADER_TITLE_PROPS = 'RESET_HEADER_TITLE_PROPS';

export default {
  CHANGE_HEADER_TITLE_PROPS,
  RESET_HEADER_TITLE_PROPS,
};
